<template>
  <div class="input-form" v-if="name != 'town'">
    <label :for="name">
      {{ label }}
      <span v-if="required" class="text-red font-bold"> * </span>
    </label>
    <Field
      :id="name"
      v-model="value"
      as="select"
      :name="name"
      :rules="rules"
      :disabled="disabled"
      class="selectForm"
    >
      <option value="" selected disabled hidden>Choisissez une option</option>
      <option v-for="option in options" :key="option.id" :value="option.id">
        {{ option.name }}
      </option>
    </Field>
    <div>
      <ErrorMessage class="errorForm" :name="name" />
    </div>
    <div>
      <span
        v-if="errors && errors[name] && errors[name][0]"
        class="errorForm"
        >{{ errors[name][0] }}</span
      >
    </div>
  </div>

  <!-- //town -->
  <div class="input-form" v-else>
    <label :for="name">
      {{ label }}
      <span v-if="required" class="text-red font-bold"> * </span>
    </label>
    <Field
      :id="name"
      v-model="value"
      as="select"
      :name="name"
      :rules="rules"
      :disabled="disabled"
      class="selectForm"
    >
      <option value="" selected disabled hidden>Choisissez une option</option>
      <option v-for="option in options" :key="option" :value="option.nom">
        {{ option.nom }}
      </option>
    </Field>
    <div>
      <ErrorMessage class="errorForm" :name="name" />
    </div>
    <div>
      <span
        v-if="errors && errors[name] && errors[name][0]"
        class="errorForm"
        >{{ errors[name][0] }}</span
      >
    </div>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
export default {
  components: {
    Field,
    ErrorMessage
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    rules: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue'],
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
}
</script>
